import { useSyncExternalStore } from 'react'

export interface ViewAsTarget {
  id: string
  name: string
  email: string
  companyName: string
}

// Held in memory, never in the URL or storage: a page refresh is one of the two
// ways out of the lens (Exit is the other), so it must not survive a reload.
let current: ViewAsTarget | null = null
const listeners = new Set<() => void>()

function emit() {
  listeners.forEach(listener => listener())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function startViewAs(target: ViewAsTarget) {
  current = target
  emit()
}

export function exitViewAs() {
  current = null
  emit()
}

export function getViewAs(): ViewAsTarget | null {
  return current
}

export function useViewAs(): ViewAsTarget | null {
  return useSyncExternalStore(subscribe, getViewAs)
}

/** The lensed user's id, for the `asUserId` the API's read endpoints take. */
export function useViewAsId(): string | undefined {
  return useViewAs()?.id
}
